export default __webpack_public_path__ + "static/media/male-img.7cd98a27.png";